import { type ReactNode } from 'react';
import { type LabelProps } from 'react-aria-components';
import { FieldLabel } from './FieldLabel';

export function FieldLabelWithHtml({ label, required, ...props }: LabelProps & { label: ReactNode; required?: boolean }) {
	return (
		<FieldLabel {...props}>
			<span dangerouslySetInnerHTML={{ __html: label as string }} />
			{required ? <span className="text-red-500"> *</span> : null}
		</FieldLabel>
	);
}
